module.exports = __webpack_public_path__ + "static/media/logu.bf8e7dcc.jpg";